import { useEffect } from 'react';

/**
 * Sends the browser to another site.
 *
 * React Router's Navigate only moves around inside this app - handed an
 * absolute URL it encodes the whole thing as an in-app path, which lands on a
 * route that does not exist. Marketing links live on www.vertivio.com, so they
 * need a real browser navigation.
 */
function ExternalRedirect({ to }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return null;
}

export default ExternalRedirect;
